<div class="hero-section">
  <div class="hero-shell">
    <div class="hero-content">
      <h1 class="hero-title">
        <span class="hero-title-line">Manufacturing Management</span>
        <span class="hero-title-line hero-title-line--second">made <span class="hero-title-highlight">precise</span>.</span>
      </h1>

      <p class="hero-description">
        From work centers and routings to standard costs, capacity, and quality —
        plan, cost, and track every production order in one system.
      </p>

      <div class="hero-buttons">
        <button class="hero-btn hero-btn-primary" type="button" (click)="showRegister = true">Start free trial</button>
        <a class="hero-btn hero-btn-secondary" href="https://calendly.com/tahir-aslam-techcolleagues/meeting-with-tahir-aslam-founder-tech-colleagues?month=2026-07" target="_blank" rel="noopener noreferrer">Book a meeting</a>
      </div>
    </div>

    <div class="hero-visual" aria-hidden="true">
      <div class="wo-card">
        <div class="wo-card-top">
          <div class="wo-icon">⚙️</div>
          <div class="wo-info">
            <span class="wo-name">Cutting Station</span>
            <span class="wo-code">Day Shift · 1 linked order</span>
          </div>
          <span class="wo-status">OK</span>
        </div>

        <div class="wo-card-row">
          <span>Required hours</span>
          <span class="wo-value">5.5h</span>
        </div>
        <div class="wo-card-row">
          <span>Available hours</span>
          <span class="wo-value">8h</span>
        </div>

        <div class="wo-bar"><div class="wo-bar-fill"></div></div>
      </div>

      <div class="floating-chip floating-chip--orders">
        <span class="floating-chip-icon">✅</span>
        <span>6 completed orders</span>
      </div>

      <div class="floating-chip floating-chip--quality">
        <span class="floating-chip-icon">🔍</span>
        <span>98% quality pass rate</span>
      </div>
    </div>
  </div>
</div>

<app-register
  *ngIf="showRegister"
  [selectedApps]="manufacturingApp"
  (goBack)="showRegister = false"
></app-register>
